// src/data/defaultServices.js

export const defaultServices = [
  // Bakım Hizmetleri
  { hizmetAdi: 'Periyodik Bakım - Tip A', aciklama: 'Bakım', fiyat: 0, tip: 'Bakım' },
  { hizmetAdi: 'Periyodik Bakım - Tip B', aciklama: 'Bakım', fiyat: 0, tip: 'Bakım' },
  { hizmetAdi: 'Koruyucu Bakım', aciklama: 'Bakım', fiyat: 0, tip: 'Bakım' },

  // Onarım Hizmetleri
  { hizmetAdi: 'Genel Onarım', aciklama: 'Onarım', fiyat: 0, tip: 'Onarım' },
  { hizmetAdi: 'Elektronik Kart Onarımı', aciklama: 'Onarım', fiyat: 0, tip: 'Onarım' },
  { hizmetAdi: 'Mekanik Aksam Onarımı', aciklama: 'Onarım', fiyat: 0, tip: 'Onarım' },

  // Kalibrasyon
  { hizmetAdi: 'Sensör Kalibrasyonu', aciklama: 'Kalibrasyon', fiyat: 0, tip: 'Kalibrasyon' },
  { hizmetAdi: 'Basınç Kalibrasyonu', aciklama: 'Kalibrasyon', fiyat: 0, tip: 'Kalibrasyon' },

  // Diğer Hizmetler
  { hizmetAdi: 'Yazılım Güncelleme', aciklama: 'Yazılım', fiyat: 0, tip: 'Yazılım' },
  { hizmetAdi: 'Parça Değişimi', aciklama: 'Onarım', fiyat: 0, tip: 'Onarım' },
  { hizmetAdi: 'Keşif / Arıza Tespiti', aciklama: 'Diğer', fiyat: 0, tip: 'Diğer' },
];